import request from '../../../../../services/axios';
import {ICashBackHistoryResponse} from './cashBackHistory.types';

interface IGetCashBackHistoryListParams {
  cashBackGuid: string;
  pageParam?: number;
}

export const getCashBackHistoryList = async ({
  cashBackGuid,
  pageParam = 1,
}: IGetCashBackHistoryListParams): Promise<ICashBackHistoryResponse> => {
  const {data} = await request.get<ICashBackHistoryResponse>(
    `/api/v2/payment/cashback/cards/history/${cashBackGuid}`,
    {
      params: {page: pageParam},
    },
  );

  return data;
};
